import { render, staticRenderFns } from "./PDAIndex.vue?vue&type=template&id=4adad1a5&scoped=true&"
import script from "./PDAIndex.vue?vue&type=script&lang=js&"
export * from "./PDAIndex.vue?vue&type=script&lang=js&"
import style0 from "./PDAIndex.vue?vue&type=style&index=0&id=4adad1a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4adad1a5",
  null
  
)

export default component.exports